// 診察データ操作サービス
export class ExaminationService {
  
  /**
   * 診察データを部分更新
   * @param {string} examinationId - 診察ID
   * @param {Object} fields - 更新するフィールド
   * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
   */
  static async update(examinationId, fields) {
    try {
      const response = await fetch(`/api/examinations/${examinationId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          examination: fields
        })
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => null)
        throw new Error(errorData?.message || `保存に失敗しました (${response.status})`)
      }

      const data = await response.json()
      return {
        success: true,
        data: data
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || '通信エラーが発生しました'
      }
    }
  }
}